import type { BackgroundValue, IconConfig } from '../types'
import { inputChecked } from '../utils/input'
import { BackgroundFields } from './BackgroundPicker'
import { Field } from './Field'
import { Panel } from './Panel'
import { SliderRow } from './SliderRow'

interface Props {
  value: IconConfig['innerFrame']
  onChange: (innerFrame: IconConfig['innerFrame']) => void
}

export function InnerFramePicker({ value, onChange }: Props) {
  const update = (patch: Partial<IconConfig['innerFrame']>) => {
    onChange({ ...value, ...patch })
  }

  const updateBackground = (background: BackgroundValue) => {
    update({ background })
  }

  return (
    <Panel title="Inner frame" description="An inset layer painted on top of the outer background, behind the content.">
      <Field label="Enabled">
        <input type="checkbox" checked={value.enabled} onChange={(event) => update({ enabled: inputChecked(event) })} />
      </Field>
      {value.enabled && (
        <>
          <SliderRow
            label="Inset"
            min={1}
            max={30}
            step={0.5}
            value={value.inset}
            display={value.inset.toFixed(1)}
            onChange={(inset) => update({ inset })}
          />
          <BackgroundFields value={value.background} onChange={updateBackground} />
        </>
      )}
    </Panel>
  )
}
